var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.skillsAndToolsPageClass},_vm._l((_vm.projects),function(project,i){return _c('div',{key:i,class:_vm.cardWrapperClass},[_c('v-card',{staticClass:"card"},[_c('v-img',{staticClass:"card-image",attrs:{"src":project.img,"contain":""}})],1)],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }